<template>
    <div class="login-method">
        <el-divider class="login-method-or">or</el-divider>
        <div class="login-method-img">
            <img src="https://img.kakaclo.com/web-img/home/login/icon_1.png" v-if="loginMethod === 'email'" @click="changeLoginMethod('mobile')">
            <img src="https://img.kakaclo.com/web-img/home/login/icon_3.png" v-else @click="changeLoginMethod('email')">
            <div style="position: relative; display: inline-block;">
                <img src="https://img.kakaclo.com/web-img/home/login/icon_2.png" alt="" data-onsuccess="googleLoginSuccessCb"  @click="isClickGoogle = true">
                <div class="g-signin2" data-onsuccess="googleLoginSuccessCb"  @click="isClickGoogle = true" style="position: absolute; opacity:0; top: 8px; left: 8px;"></div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
  props: {
    loginMethod: {
      type: String,
      require: true,
      default: 'email'
    }
  },
  data() {
    return {

    }
  },
  methods: {
    changeLoginMethod(method) {
      this.$emit('changeLoginMethod', method)
    }
  }
}
</script>

<style lang="scss" scoped>
.login-method {
    text-align: center;
    img {
        width: 32px;
        margin: 10px;
        cursor: pointer;
    }
}
</style>

